import RoleEnum from '@/domains/authentication/typescript/RoleEnum';
import type OfficeUserInterface from '@/domains/office/typescript/OfficeUserInterface';

const defaultOfficeUser: OfficeUserInterface = {
    '@id': '',
    id: '',
    user: {
        id: '',
        email: '',
        firstName: '',
        lastName: '',
        isActive: true,
    },
    office: {
        id: '',
        name: '',
        admin: '',
        address: '',
        phone: '',
        assets: [],
        production: [],
        manufacturingType: [],
    },
    roles: RoleEnum.ROLE_USER,
    holder: false,
};

export { defaultOfficeUser };
